import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '界面变量',
    textProp: 'algTitle',
    type: 'UI_VARIABLE',
}
